var angular = require('angular');

var app_deps = [
  require("amt_admin"),
  require("./dashboard"),
  require("./life_time"),
  require("./purchases"),
  require("./retention"),
  require('./sessions'),
  require("./conversion_rate"),
  require("./admin_migration"),
  require("./admin_restore"),
  require("./admin_events"),
  require("./admin_tasks"),
];
if (GAMEPLAY != 'adult_idler') {
  app_deps.push(
    require("./game_events"),
    require("./buildings"),
    require("./arpu_arppu"),
    require("./versions"),
    require("./video"),
    require("./tutorial"),
    require("./offers"),
    require("./single_arena"),
    require("./rating_arena"),
    require("./runner_battler"),
    require("./gold"),
    require("./economics"),
    require("./units"),
    require("./features"),
    require("./paywalls"),
    require("./invited_players"),
    require("./alliance_war"),
    require("./alliance"),
    require("./players_power"),
  );
}
var app = angular.module("ww2_analytics", app_deps.map(x => x.default));

require("./common/installs_table").default(app);
require("./common/simple_table").default(app);

app.factory("chartFilters", [
  "$location",
  "$rootScope",
  function($location, $rootScope) {
    return {
      chartParams: {},
      consumers: {},
      init_chart_filters: function() {
        this.chartParams = {
          filters: angular.fromJson($location.search().filters || "{}")
        };
        this.chartParams.filters._timezone_offset =
          new Date().getTimezoneOffset() / 60;
        this.consumers = {};
        return this.chartParams;
      },
      get_chart_filters: function() {
        return this.chartParams;
      },
      update_chart_filters: function(model) {
        var _context = {
          _timezone_offset: new Date().getTimezoneOffset() / 60
        };

        angular.forEach(
          model,
          function(value, key) {
            if (key.indexOf("_") !== 0) {
              this[key] = value;
              $rootScope.chartParams.filters[key] = value;
            }
          },
          _context
        );

        this.chartParams.filters = _context;

        for (var consumer_name in this.consumers) {
          this.consumers[consumer_name](this.chartParams);
        }

        $location.search("filters", angular.toJson(_context));
      },
      onChangeChartParams: function(name, callback) {
        this.consumers[name] = callback;
      }
    };
  }
]);

app.filter("secondsToDateTime", [
  function() {
    return function(seconds) {
      return new Date(1970, 0, 1).setSeconds(seconds);
    };
  }
]);

app.filter("totalSum", function() {
  return function(data, key, count_type, median) {
    var sum = 0;
    if (data.length < 1) {
      return sum;
    }
    angular.forEach(data, function(value) {
      var val = 0;
      if (count_type == "float") {
        val = parseFloat(value[key]);
      } else {
        val = parseInt(value[key]);
      }
      sum = sum + val;
    });
    if (median) {
      sum = sum / data.length;
    }
    return sum;
  };
});

app.directive("filterState", function() {
  return {
    controller: [
      "$scope",
      "$rootScope",
      function FilterStateCtrl($scope, $rootScope) {
        $scope.filterData = {};
        $scope.filterDates = "";

        var formatDate = function(dt) {
          if (_.isString(dt)) {
            dt = moment(dt);
          }
          return dt.local().format("YYYY-MM-DD");
        }
        var performData = function() {
          angular.forEach(
            $rootScope.chartParams.filters,
            function(value, key) {
              if (key == "dates") {
                $scope.filterDates =
                  formatDate(value.startDate) + " - " + formatDate(value.endDate);
              } else if (key[0] == "_") {
                // nothing
              } else if (value == null) {
                // nothing
              } else if (value.length < 1) {
                delete this[key];
              } else if (Array.isArray(value)) {
                this[key] = value.join(",");
              } else {
                this[key] = value;
              }
            },
            $scope.filterData
          );
        };

        performData();
        $rootScope.$watch(
          "chartParams",
          function(_newValue, _oldValue) {
            performData();
          },
          true
        );
      }
    ],
    template:
      '<b>{{filterDates}}</b>: <span class="btn btn-xs btn-success" ng-repeat="(key, value) in filterData">{{key}}: {{value}}</span>'
  };
});

app.component("bfgChart", {
  template:
    '<amt-chart name="{{$ctrl.name}}" params="$ctrl.chartParams"></amt-chart>',
  bindings: {
    name: "@"
  },
  controller: [
    "chartFilters",
    function(chartFilters) {
      this.chartParams = chartFilters.chartParams;
      var self = this;

      chartFilters.onChangeChartParams(this.name, function(chartParams) {
        self.chartParams = angular.copy(chartParams);
      });
    }
  ]
});

app
  .run([
    "$rootScope",
    "chartFilters",
    function($rootScope, chartFilters) {
      $rootScope.$on("$stateChangeStart", function(
        _event,
        _toState,
        _toParams,
        _fromState,
        _fromParams
      ) {
        $rootScope.chartParams = chartFilters.init_chart_filters();
      });
    }
  ])
  .config([
    "$stateProvider",
    function($stateProvider) {
      $stateProvider
        .state("amt.ww2", {
          url: "?filters",
          reloadOnSearch: false,
          template:
            "" +
            "<div ng-show='!$state.$current.data.hidden_filters' class='row'>" +
            "   <div ng-show='isOpened' class='col-lg-12' ui-view='main-filter'>" +
            "       <amt-form-inline" +
            "           name='segments.EventSegmentsForm'" +
            "           on-submit='updateCharts(model)'" +
            "           extend-model='$root.chartParams.filters'" +
            "       ></amt-form-inline>" +
            "   </div>" +
            "<div class='col-md-12'>" +
            "<div class='well well-lg'>" +
            "<filter-state></filter-state>" +
            "<button type='button' class='btn btn-default pull-right' ng-click='isOpened = !isOpened'>" +
            "<span ng-if='isOpened'>Close</span>" +
            "<span ng-if='!isOpened'>Filter</span>" +
            "</button>" +
            "</div>" +
            "</div>" +
            "</div>" +
            "<div class='row'><div class='col-md-12' ui-view></div></div>" +
            "",
          controller: [
            "chartFilters",
            "$scope",
            function(chartFilters, $scope) {
              $scope.updateCharts = function(model) {
                if (model !== undefined) {
                  chartFilters.update_chart_filters(model);
                  $scope.isOpened = true;
                }
              };
            }
          ]
        })
        .state("amt.ww2.admin", {
          url: "/admin",
          abstract: true,
          template:
            "<div class='row'><div class='col-md-12' ui-view></div></div>",
          data: {
            priority: -1,
            title: "Admin",
            role: "admin",
            hidden_filters: true
          },
          menu: {
            fa_icon: "mortar-board",
            position: "top",
            childs_auto: true
          }
        });
    }
  ]);

require("amt_admin/bootstrap").default("ww2_analytics");
